<template>
    <div>
       
        <b-card no-body class="overflow-hidden mb-2" border-variant="primary">

            <div class="position-relative">
                <div class="mx-auto w-100 position-absolute h-100 d-flex align-items-end ">
                    <div class="StarResultcard p-2 mx-auto text-center shadow">
                        <h5>{{ mainName }} 與 {{ secName }} 的契合度</h5>
                        <div class="py-2">

                            <div v-if="scroeData.length > 0">

                                <b-img  v-for="(item , index) in scroeData" v-bind:key="index" :src="item.icontype"
                                        class="mx-1">

                                </b-img>

                            </div>

                            <p v-else class="text-primary">
                                雙方沒有好與壞的影響
                            </p>
                        </div>
                    </div>
                </div>
                <b-card-img :src="CoverSrc(coverType)" alt="Image" top ></b-card-img>
            </div>


            <b-list-group flush>

                <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index">
                    <div class="">
                        <div>
                            <b-img v-for="(staritem , indexin) in Number(listdata[index].score)" v-bind:key="indexin"
                                   :src="StarSrc(starType,listdata[index].score_status=='0'?'Light':'Dark')"
                                   style="height: 20px"

                            >

                            </b-img>


                        </div>
                        {{ item.result }}
                    </div>


                </b-list-group-item>
            </b-list-group>


        </b-card>
        <TipsAlert :tipswords="masterTips.tipswords"
                   :status="masterTips.status"
                   :videostatus="masterTips.videostatus"
                   :videosrc="masterTips.videosrc">

        </TipsAlert>
    </div>

</template>
<style>

    .StarResultcard {

        background-color: #fff;
        width: 80%;
        margin-bottom: 30px;
        top: 80px;
        border-radius: 1rem !important;
    }
</style>
<script>
import TipsAlert from '@/components/TipsAlert.vue'

export default {
  name: 'CompareCard',
  components: {TipsAlert},

  props: {
    listdata: Array,
    mainName: String,
    secName: String,
    starType: String,
    coverType: String,

  },
  computed: {

    scroeData: function () {return this.countScroe()},
  },
  data () {
    return {
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'（契合度符號含義）人與人之間，無形中會有相吸與相剋的關係，如果圖形出現黑色圖型的話，就是對你比較差的契合，好的契合圖形都會有顏色(EX:黃色or紅色)，但好與壞還是有嚴重與輕微的差異，你可以看看圖形下方的解釋文字。',
      },
      countScroe: function () {

        let newAry = []
        let goodscore = 0
        let badscore = 0

        for (let i = 0; i < this.listdata.length; i++) {
          let iconnumber = Number(this.listdata[i].score)

          if (this.listdata[i].score_status == '0') {
            goodscore = goodscore + iconnumber

          } else {
            badscore = badscore + iconnumber

          }


        }


        if (goodscore == 0 && badscore == 0) {
          // Array.prototype.push.apply(newAry, [{
          //   icontype: '',
          // }])
        }

        if (goodscore > 0) {
          for (let i = 0; i < goodscore; i++) {
            Array.prototype.push.apply(newAry, [{
              icontype: this.StarSrc(this.starType,'Light'),
            }])
          }
        }
        if (badscore > 0) {
          for (let i = 0; i < badscore; i++) {
            Array.prototype.push.apply(newAry, [{
              icontype: this.StarSrc(this.starType,'Dark'),
            }])
          }
        }


        return newAry

      },
      StarSrc(type,way){
        let Lightimagesrc = ''
        let Darkimagesrc = ''
        let returnSrc=''
        switch (type) {
          case 'money':
            Lightimagesrc = require('../assets/ui/money.png')
            Darkimagesrc = require('../assets/ui/money_dark.png')
            break
          case 'love':
            Lightimagesrc = require('../assets/ui/love.png')
            Darkimagesrc = require('../assets/ui/love_dark.png')
            break
          case 'star':
            Lightimagesrc = require('../assets/ui/star.png')
            Darkimagesrc = require('../assets/ui/star_dark.png')
            break
        }
        if(way=='Light'){
          returnSrc = Lightimagesrc
        }
        if(way=='Dark'){
          returnSrc = Darkimagesrc
        }

        return returnSrc;

      },
      CoverSrc(type){
        let returnSrc=''
        switch (type) {
          case 'client':
            returnSrc = require('../assets/story/client_1.gif')

            break
          case 'colluague':
            returnSrc = require('../assets/story/colluague_1.gif')

            break
          case 'love':
            returnSrc = require('../assets/story/lover-card.gif')

            break
          case 'releative':
            returnSrc = require('../assets/story/releative_1.gif')

            break
        }
        return returnSrc;
      }
    }
  },
  methods: {}
}
</script>
